export default __webpack_public_path__ + "static/media/6MD63.0c95f592.jpg";